import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { SkyUiTooltipDirective } from './directive/tooltip';
import { SkyUiTooltipComponent } from './component/tooltip/tooltip';
import { SKY_UI_TOOLTIP_COMPONENT } from './const';
import { SkySwipeControllerModule } from '@skyeng/libs/shared/misc';

/**
 * @deprecated(Use DsTooltipModule from @skyeng/libs/shared/ui-kit-v2/tooltip instead)
 */
@NgModule({
  imports: [CommonModule, OverlayModule, SkySwipeControllerModule],
  providers: [{ provide: SKY_UI_TOOLTIP_COMPONENT, useValue: SkyUiTooltipComponent }],
  declarations: [SkyUiTooltipDirective, SkyUiTooltipComponent],
  exports: [SkyUiTooltipDirective],
})
export class SkyUiTooltipModule {}
